import React, { useCallback, useEffect, useState } from "react";

import CoachHistoryDialog from "../../History/CoachHistory/CoachHistoryDialog";

import {

  Alert,

  Box,

  Button,

  Card,

  CardContent,

  Chip,

  CircularProgress,

  Dialog,

  DialogActions,

  DialogContent,

  DialogTitle,

  Divider,

  Grid,

  IconButton,

  InputAdornment,

  MenuItem,

  Tabs,

  Tab,

  Paper,

  Stack,

  Table,

  TableBody,

  TableCell,

  TableContainer,

  TableHead,

  TablePagination,

  TableRow,

  TextField,

  Tooltip,

  Typography,

  useMediaQuery,

} from "@mui/material";

import { useTheme } from "@mui/material/styles";

import SearchIcon from "@mui/icons-material/Search";

import RefreshIcon from "@mui/icons-material/Refresh";

import HistoryIcon from "@mui/icons-material/History";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import CloseIcon from "@mui/icons-material/Close";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import dayjs from "dayjs";

import api from "../../../services/api";

const initialForm = {
  physical_shop_date: dayjs().format("YYYY-MM-DD"),
  next_return_date: "",
  gate_out_time: dayjs().format("HH:mm"),
  remark: "",
};

const toDateInputValue = (value) => {
  if (!value) return "";
  const raw = String(value);
  // Preserve MySQL DATE values without timezone conversion.
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  // For ISO timestamps, use the local calendar date.
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

const formatDate = (value) => {
  if (!value) return "—";
  const parsed = dayjs(toDateInputValue(value));
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : String(value);
};

const getErrorMessage = (error) =>

  error?.response?.data?.message ||

  error?.response?.data?.error ||

  error?.message ||

  "Something went wrong";

export default function TechnicalShell() {

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));


  

  const [rows, setRows] = useState([]);

  const [loading, setLoading] = useState(false);

  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");

  const [success, setSuccess] = useState("");

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");

  const [status, setStatus] = useState("IN_YARD");

  const [formOpen, setFormOpen] = useState(false);

  const [selected, setSelected] = useState(null);

  const [form, setForm] = useState(initialForm);

  const [historyOpen, setHistoryOpen] = useState(false);

  const [historyCoachNo, setHistoryCoachNo] = useState("");

  // Coach master edit state

  const [coachEditOpen, setCoachEditOpen] = useState(false);

  const [coachEditSaving, setCoachEditSaving] = useState(false);

  const [coachEditId, setCoachEditId] = useState(null);



  

  const [coachEditForm, setCoachEditForm] = useState({

    coach_no: "",

    coach_type_code: "",

    railway_code: "",

    base_code: "",

    make_code: "",

    year_built: "",

    last_poh_date: "",

    last_out_date: "",

    repair_type_code: "",

    remark: "",

    status: "ACTIVE",

  });

  const [coachMasters, setCoachMasters] = useState({

    coachTypes: [],

    railways: [],

    makes: [],

    repairTypes: [],

    bases: [],

  });

  const fetchRows = useCallback(async () => {

    setLoading(true);

    setError("");

    try {

      const response = await api.get("/technical-shell", {

        params: {

          page: page + 1,

          limit: rowsPerPage,

          search: search.trim(),

          status,

        },

      });

      const data = response.data || {};

      const list = data.data || data.rows || [];

      setRows(Array.isArray(list) ? list : []);

      setTotal(

        Number(

          data.total ??

            data.pagination?.total ??

            data.pagination?.totalRecords ??

            0,

        ),

      );

    } catch (err) {

      setError(getErrorMessage(err));

      setRows([]);

      setTotal(0);

    } finally {

      setLoading(false);

    }

  }, [page, rowsPerPage, search, status]);

  useEffect(() => {

    fetchRows();

  }, [fetchRows]);

  const openOutturnDialog = (row) => {

    setSelected(row);

  setForm({
  ...initialForm,
  physical_shop_date: dayjs().format("YYYY-MM-DD"),
  next_return_date: "",
  gate_out_time: dayjs().format("HH:mm"),
  remark: row?.technical_remark || "",
});

    setError("");

    setSuccess("");

    setFormOpen(true);

  };

  const closeOutturnDialog = () => {

    if (saving) return;

    setFormOpen(false);

    setSelected(null);

  };

  const handleFormChange = (event) => {

    const { name, value } = event.target;

    setForm((previous) => ({ ...previous, [name]: value }));

  };

  const handleSave = async () => {

    if (!selected?.visit_id) {

      setError("Visit ID is missing.");

      return;

    }

    if (!form.physical_shop_date) {

      setError("Please select the physical outturn date.");

      return;

    }

    if (!form.gate_out_time) {

      setError("Please enter the gate-out time.");

      return;

    }

    setSaving(true);

    setError("");

    try {

      await api.put(`/technical-shell/${selected.visit_id}`, {

        physical_shop_date: form.physical_shop_date,

        next_return_date: form.next_return_date,

        gate_out_time: form.gate_out_time,

        remark: form.remark.trim(),

      });

      setFormOpen(false);

      setSelected(null);

      setSuccess(

        `Physical outturn saved successfully for ${selected.coach_no || "the coach"}.`,

      );

      await fetchRows();

    } catch (err) {

      setError(getErrorMessage(err));

    } finally {

      setSaving(false);

    }

  };

  // Edit is shown from the Pending tab for records that have not gated out.




  

 const isPendingYardCoach = (row) =>
  status === "IN_YARD" &&
  String(row?.status || "").toUpperCase() === "YARD" &&
  !row?.gate_out_date;

 const openCoachEdit = async (row) => {
  const id =
    row?.coach_id ??
    row?.master_coach_id ??
    row?.coach_master_id ??
    row?.id;

  if (!id) {
    setError("Coach master ID is missing in this record.");
    return;
  }

  setError("");
  setSuccess("");

  try {
    const [coachRes, masterRes] = await Promise.all([
      api.get(`/coaches/${id}`),
      api.get("/coaches/masters"),
    ]);

    const coach = coachRes.data?.data;
    const md = masterRes.data?.data || {};

    if (!coach) {
      throw new Error("Coach details not found.");
    }

    const normalizeCode = (value) =>
      String(value ?? "").trim().toUpperCase();

    const railways = Array.isArray(md.railways)
      ? md.railways
      : [];

    console.log("Coach railway:", coach.railway_code);
    console.log("Coach base:", coach.base_code);

    console.log(
      "Railway options:",
      railways.map((x) => ({
        id: x.id,
        code: x.code,
        name: x.name,
      }))
    );

    const railway = railways.find(
      (item) =>
        normalizeCode(item.code) ===
        normalizeCode(coach.railway_code)
    );

    let bases = [];

    if (railway?.id) {
      const baseRes = await api.get(
        `/coaches/bases-by-railway/${railway.id}`
      );

      bases = Array.isArray(baseRes.data?.data)
        ? baseRes.data.data
        : [];
    }

    console.log(
      "Base options:",
      bases.map((x) => ({
        id: x.id,
        base_code: x.base_code,
        base_name: x.base_name,
      }))
    );

    setCoachMasters({
      coachTypes: md.coachTypes || [],
      railways,
      makes: md.makes || [],
      repairTypes: md.repairTypes || [],
      bases,
    });

    setCoachEditId(coach.id ?? id);

    setCoachEditForm({
      coach_no: coach.coach_no || "",
      coach_type_code: coach.coach_type_code || "",
      railway_code: coach.railway_code || "",
      base_code: coach.base_code || "",
      make_code: coach.make_code || "",
      year_built: coach.year_built ?? "",
      last_poh_date: toDateInputValue(coach.last_poh_date),
      last_out_date: toDateInputValue(coach.last_out_date),
      repair_type_code: coach.repair_type_code || "",
      remark: coach.remark || "",
      status: coach.status || "ACTIVE",
    });

    setCoachEditOpen(true);
  } catch (err) {
    console.error("openCoachEdit error:", err);
    setError(getErrorMessage(err));
  }
};

  const saveCoachEdit = async () => {

    if (!coachEditId || !coachEditForm.coach_type_code) {

      setError("Coach type is required.");

      return;

    }

    setCoachEditSaving(true);

    setError("");

    try {

      const payload = {

        ...coachEditForm,

        coach_no: undefined,

        railway_code: coachEditForm.railway_code || null,

        base_code: coachEditForm.base_code || null,

        make_code: coachEditForm.make_code || null,

        year_built: coachEditForm.year_built || null,

        last_poh_date: coachEditForm.last_poh_date || null,

        last_out_date: coachEditForm.last_out_date || null,

        repair_type_code: coachEditForm.repair_type_code || null,

        remark: coachEditForm.remark.trim() || null,

      };

      delete payload.coach_no;

      await api.put(`/coaches/${coachEditId}`, payload);

      setCoachEditOpen(false);

      setSuccess(`Coach master updated for ${coachEditForm.coach_no}.`);

      await fetchRows();

    } catch (e) {

      setError(getErrorMessage(e));

    } finally {

      setCoachEditSaving(false);

    }

  };

  // Keep the original working coach-history dialog behavior.

  const openHistory = (row) => {

    setHistoryCoachNo(row?.coach_no || "");

    setHistoryOpen(true);

  };

  const statusChip = (value) => {

    const normalized = String(value || "").toUpperCase();

    if (normalized === "GATE_OUT") {

      return <Chip size="small" label="Gate Out" color="success" />;

    }

    if (normalized === "PENDING") {

      return <Chip size="small" label="Pending" color="warning" />;

    }

    return <Chip size="small" label={value || "—"} variant="outlined" />;

  };

  const renderMobileCard = (row) => (

    <Card key={row.visit_id} variant="outlined" sx={{ mb: 1.5 }}>

      <CardContent>

        <Stack spacing={1.2}>

          <Stack

            direction="row"

            justifyContent="space-between"

            alignItems="flex-start"

            gap={1}

          >

            <Box>

              <Typography fontWeight={700}>

                {row.coach_no || "Unknown coach"}

              </Typography>

              <Typography variant="body2" color="text.secondary">

                Visit: {row.visit_no || row.visit_id}

              </Typography>

            </Box>

            {statusChip(row.status)}

          </Stack>

          <Divider />

          <Grid container spacing={1}>

            <Grid item xs={6}>

              <Typography variant="caption" color="text.secondary">

                Coach Type

              </Typography>

              <Typography variant="body2">

                {row.coach_type_code || row.coach_type || "—"}

              </Typography>

            </Grid>

            <Grid item xs={6}>

              <Typography variant="caption" color="text.secondary">

                POH Date

              </Typography>

              <Typography variant="body2">

                {formatDate(row.poh_date)}

              </Typography>

            </Grid>

            <Grid item xs={6}>

              <Typography variant="caption" color="text.secondary">

                Gate In

              </Typography>

              <Typography variant="body2">

                {formatDate(row.gate_in_date)}

              </Typography>

            </Grid>

            <Grid item xs={6}>

              <Typography variant="caption" color="text.secondary">

                Current Location

              </Typography>

              <Typography variant="body2">

                {row.current_location_code || row.current_location_type || "—"}

              </Typography>

            </Grid>

          </Grid>

          <Stack direction="row" spacing={1} justifyContent="flex-end">

            {isPendingYardCoach(row) && (

              <Button

                size="small"

                variant="outlined"

                color="primary"

                startIcon={<EditOutlinedIcon />}

                onClick={() => openCoachEdit(row)}

              >

                Edit Coach

              </Button>

            )}

            <Tooltip title="View history">

              <IconButton

                size="small"

                color="primary"

                onClick={() => openHistory(row)}

              >

                <HistoryIcon />

              </IconButton>

            </Tooltip>

{!["GETOUT", "GATE_OUT"].includes(
  String(row?.status || "").toUpperCase()
) && !row?.gate_out_date && (
              <Button

                size="small"

                variant="contained"

                startIcon={<ExitToAppIcon />}

                onClick={() => openOutturnDialog(row)}

              >

                Physical Out

              </Button>

            )}

          </Stack>

        </Stack>

      </CardContent>

    </Card>

  );

  return (

    <Box sx={{ p: { xs: 1, sm: 2, md: 3 }, width: "100%", minWidth: 0 }}>

      <Stack

        direction={{ xs: "column", sm: "row" }}

        justifyContent="space-between"

        alignItems={{ xs: "stretch", sm: "center" }}

        spacing={1.5}

        sx={{ mb: 2 }}

      >

        <Box>

          <Typography variant="h5" fontWeight={700}>

            Technical Shell – Physical Outturn

          </Typography>

          <Typography variant="body2" color="text.secondary">

            Record physical outturn and complete the workshop gate-out process.

          </Typography>

        </Box>

        <Button

          variant="outlined"

          startIcon={<RefreshIcon />}

          onClick={fetchRows}

          disabled={loading}

        >

          Refresh

        </Button>

      </Stack>

      {error && !formOpen && !historyOpen && (

        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>

          {error}

        </Alert>

      )}

      {success && (

        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>

          {success}

        </Alert>

      )}

      <Paper variant="outlined" sx={{ p: 1.5, mb: 2 }}>

        <Stack

          direction={{ xs: "column", sm: "row" }}

          spacing={1.5}

          alignItems={{ xs: "stretch", sm: "center" }}

        >

          <TextField

            size="small"

            fullWidth

            placeholder="Search coach no, visit no..."

            value={search}

            onChange={(event) => {

              setSearch(event.target.value);

              setPage(0);

            }}

            InputProps={{

              startAdornment: (

                <InputAdornment position="start">

                  <SearchIcon fontSize="small" />

                </InputAdornment>

              ),

            }}

          />

         <Tabs
  value={status}
  onChange={(_, value) => {
    setStatus(value);
    setPage(0);
  }}
  variant={isMobile ? "fullWidth" : "standard"}
  scrollButtons={!isMobile ? "auto" : false}
  allowScrollButtonsMobile
  sx={{
    minHeight: 44,
    borderBottom: 1,
    borderColor: "divider",
    flexShrink: 0,
  }}
>
  {[
    { value: "IN_YARD", label: "In Yard" },
    { value: "PENDING", label: "Pending" },
    { value: "GATE_OUT", label: "Gate Out" },
  ].map((tab) => (
    <Tab
      key={tab.value}
      value={tab.value}
      label={tab.label}
      sx={{
        minHeight: 44,
        textTransform: "none",
        fontWeight: 700,
      }}
    />
  ))}
</Tabs>

        </Stack>

      </Paper>

      {isMobile ? (

        <Box>

          {loading ? (

            <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>

              <CircularProgress />

            </Box>

          ) : rows.length ? (

            rows.map(renderMobileCard)

          ) : (

            <Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>

              <Typography color="text.secondary">No records found.</Typography>

            </Paper>

          )}

          <TablePagination

            component="div"

            count={total}

            page={page}

            onPageChange={(_, nextPage) => setPage(nextPage)}

            rowsPerPage={rowsPerPage}

            onRowsPerPageChange={(event) => {

              setRowsPerPage(parseInt(event.target.value, 10));

              setPage(0);

            }}

            rowsPerPageOptions={[5, 10, 25, 50]}

          />

        </Box>

      ) : (

        <Paper variant="outlined" sx={{ width: "100%", overflow: "hidden" }}>

          <TableContainer sx={{ maxHeight: "65vh" }}>

            <Table stickyHeader size="small">

              <TableHead>

                <TableRow>

                  {[

                    "S.No.",

                    "Visit No.",

                    "Coach No.",

                    "Coach Type",

                    "POH Date",

                    "Gate In Date",

                    "Location",

                    "Status",

                    "Actions",

                  ].map((heading) => (

                    <TableCell

                      key={heading}

                      sx={{

                        fontWeight: 700,

                        bgcolor: "grey.100",

                        whiteSpace: "nowrap",

                      }}

                    >

                      {heading}

                    </TableCell>

                  ))}

                </TableRow>

              </TableHead>

              <TableBody>

                {loading ? (

                  <TableRow>

                    <TableCell colSpan={9} align="center" sx={{ py: 5 }}>

                      <CircularProgress size={28} />

                    </TableCell>

                  </TableRow>

                ) : rows.length ? (

                  rows.map((row, index) => (

                    <TableRow key={row.visit_id} hover>

                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>

                      <TableCell>{row.visit_no || row.visit_id}</TableCell>

                      <TableCell sx={{ fontWeight: 600 }}>

                        {row.coach_no || "—"}

                      </TableCell>

                      <TableCell>

                        {row.coach_type_code || row.coach_type || "—"}

                      </TableCell>

                      <TableCell>{formatDate(row.poh_date)}</TableCell>

                      <TableCell>{formatDate(row.gate_in_date)}</TableCell>

                      <TableCell>

                        {row.current_location_code ||

                          row.current_location_type ||

                          "—"}

                      </TableCell>

                      <TableCell>{statusChip(row.status)}</TableCell>

                      <TableCell>

                        <Stack direction="row" spacing={0.5}>

                          {isPendingYardCoach(row) && (

                            <Tooltip title="Edit coach master">

                              <IconButton

                                size="small"

                                color="warning"

                                onClick={() => openCoachEdit(row)}

                              >

                                <EditOutlinedIcon fontSize="small" />

                              </IconButton>

                            </Tooltip>

                          )}

                          <Tooltip title="View history">

                            <IconButton

                              size="small"

                              color="primary"

                              onClick={() => openHistory(row)}

                            >

                              <HistoryIcon fontSize="small" />

                            </IconButton>

                          </Tooltip>

                          {row.status !== "GATE_OUT" && !row.gate_out_date && (

                            <Tooltip title="Record physical outturn">

                              <IconButton

                                size="small"

                                color="success"

                                onClick={() => openOutturnDialog(row)}

                              >

                                <ExitToAppIcon fontSize="small" />

                              </IconButton>

                            </Tooltip>

                          )}

                        </Stack>

                      </TableCell>

                    </TableRow>

                  ))

                ) : (

                  <TableRow>

                    <TableCell colSpan={9} align="center" sx={{ py: 5 }}>

                      No records found.

                    </TableCell>

                  </TableRow>

                )}

              </TableBody>

            </Table>

          </TableContainer>

          <TablePagination

            component="div"

            count={total}

            page={page}

            onPageChange={(_, nextPage) => setPage(nextPage)}

            rowsPerPage={rowsPerPage}

            onRowsPerPageChange={(event) => {

              setRowsPerPage(parseInt(event.target.value, 10));

              setPage(0);

            }}

            rowsPerPageOptions={[5, 10, 25, 50]}

          />

        </Paper>

      )}

      {/* Physical outturn dialog */}

      <Dialog

        open={formOpen}

        onClose={closeOutturnDialog}

        fullWidth

        maxWidth="sm"

      >

        <DialogTitle sx={{ pr: 6 }}>

          Record Physical Outturn

          <IconButton

            onClick={closeOutturnDialog}

            disabled={saving}

            sx={{ position: "absolute", right: 12, top: 12 }}

          >

            <CloseIcon />

          </IconButton>

        </DialogTitle>

        <DialogContent dividers>

          {error && (

            <Alert severity="error" sx={{ mb: 2 }}>

              {error}

            </Alert>

          )}

          {selected && (

            <Paper

              variant="outlined"

              sx={{ p: 1.5, mb: 2, bgcolor: "action.hover" }}

            >

              <Grid container spacing={1}>

                <Grid item xs={6}>

                  <Typography variant="caption" color="text.secondary">

                    Coach No.

                  </Typography>

                  <Typography fontWeight={700}>

                    {selected.coach_no || "—"}

                  </Typography>

                </Grid>

                <Grid item xs={6}>

                  <Typography variant="caption" color="text.secondary">

                    Visit No.

                  </Typography>

                  <Typography fontWeight={700}>

                    {selected.visit_no || selected.visit_id}

                  </Typography>

                </Grid>

                <Grid item xs={6}>

                  <Typography variant="caption" color="text.secondary">

                    POH Date

                  </Typography>

                  <Typography>{formatDate(selected.poh_date)}</Typography>

                </Grid>

                <Grid item xs={6}>

                  <Typography variant="caption" color="text.secondary">

                    Gate In

                  </Typography>

                  <Typography>{formatDate(selected.gate_in_date)}</Typography>

                </Grid>

              </Grid>

            </Paper>

          )}

          <Stack spacing={2}>

            <TextField

              name="physical_shop_date"

              label="Physical Outturn Date"

              type="date"

              value={form.physical_shop_date}

              onChange={handleFormChange}

              fullWidth

              required

              InputLabelProps={{ shrink: true }}

            />

           <TextField
  name="next_return_date"
  fullWidth
  label="Next Visit Date"
  type="date"
  value={form.next_return_date}
  onChange={handleFormChange}
  InputLabelProps={{ shrink: true }}
  inputProps={{
    min: form.physical_shop_date || undefined,
  }}
/>

            <TextField

              name="gate_out_time"

              label="Gate Out Time"

              type="time"

              value={form.gate_out_time}

              onChange={handleFormChange}

              fullWidth

              required

              InputLabelProps={{ shrink: true }}

            />

            <TextField

              name="remark"

              label="Remarks"

              value={form.remark}

              onChange={handleFormChange}

              fullWidth

              multiline

              minRows={3}

              placeholder="Enter remarks, if any"

            />

            <Alert severity="info">

              Saving this record will mark the visit as Gate Out and update the

              coach's latest POH and outturn dates in the master record.

            </Alert>

          </Stack>

        </DialogContent>

        <DialogActions sx={{ p: 2 }}>

          <Button onClick={closeOutturnDialog} disabled={saving}>

            Cancel

          </Button>

          <Button

            variant="contained"

            color="success"

            onClick={handleSave}

            disabled={saving}

            startIcon={

              saving ? <CircularProgress size={16} color="inherit" /> : null

            }

          >

            {saving ? "Saving..." : "Save Physical Out"}

          </Button>

        </DialogActions>

      </Dialog>

      {/* Coach Master edit dialog */}

      <Dialog

        open={coachEditOpen}

        onClose={() => !coachEditSaving && setCoachEditOpen(false)}

        fullWidth

        maxWidth="md"

      >

        <DialogTitle>Edit Coach Master</DialogTitle>

        <DialogContent dividers>

          <Stack spacing={2} sx={{ pt: 1 }}>

            <TextField

              label="Coach Number"

              value={coachEditForm.coach_no}

              disabled

              fullWidth

            />

            <TextField

              select

              label="Coach Type"

              value={coachEditForm.coach_type_code}

              onChange={(e) =>

                setCoachEditForm((p) => ({

                  ...p,

                  coach_type_code: e.target.value,

                }))

              }

              fullWidth

              required

            >

              {(coachMasters.coachTypes || []).map((x) => (

                <MenuItem key={x.code} value={x.code}>

                  {x.name} ({x.code})

                </MenuItem>

              ))}

            </TextField>

            <TextField

              select

              label="Railway"

              value={coachEditForm.railway_code}

              onChange={async (e) => {

                const code = e.target.value;

                const rw = coachMasters.railways.find(
                  (x) =>
                    String(x.code ?? "").trim().toUpperCase() ===
                    String(code ?? "").trim().toUpperCase()
                );

                setCoachEditForm((p) => ({

                  ...p,

                  railway_code: code,

                  base_code: "",

                }));

                try {

                  const r = rw?.id

                    ? await api.get(`/coaches/bases-by-railway/${rw.id}`)

                    : null;

                  setCoachMasters((p) => ({

                    ...p,

                    bases: Array.isArray(r?.data?.data) ? r.data.data : [],

                  }));

                } catch (err) {

                  setError(getErrorMessage(err));

                }

              }}

              fullWidth

            >

              <MenuItem value="">None</MenuItem>

              {(coachMasters.railways || []).map((x) => (

                <MenuItem key={x.code} value={x.code}>

                  {x.name} ({x.code})

                </MenuItem>

              ))}

            </TextField>

            <TextField

              select

              label="Coach Base"

              value={coachEditForm.base_code}

              onChange={(e) =>

                setCoachEditForm((p) => ({ ...p, base_code: e.target.value }))

              }

              fullWidth

            >

              <MenuItem value="">None</MenuItem>

              {(coachMasters.bases || []).map((x) => (

                <MenuItem key={x.base_code} value={x.base_code}>

                  {x.base_name} ({x.base_code})

                </MenuItem>

              ))}

            </TextField>

            <TextField

              select

              label="Make"

              value={coachEditForm.make_code}

              onChange={(e) =>

                setCoachEditForm((p) => ({ ...p, make_code: e.target.value }))

              }

              fullWidth

            >

              <MenuItem value="">None</MenuItem>

              {(coachMasters.makes || []).map((x) => (

                <MenuItem key={x.code} value={x.code}>

                  {x.name} ({x.code})

                </MenuItem>

              ))}

            </TextField>

            <TextField

              label="Year Built"

              type="number"

              value={coachEditForm.year_built}

              onChange={(e) =>

                setCoachEditForm((p) => ({ ...p, year_built: e.target.value }))

              }

              fullWidth

            />

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>

              <TextField

                label="Last POH Date"

                type="date"

                value={coachEditForm.last_poh_date}

                onChange={(e) =>

                  setCoachEditForm((p) => ({

                    ...p,

                    last_poh_date: e.target.value,

                  }))

                }

                InputLabelProps={{ shrink: true }}

                fullWidth

              />

              <TextField

                label="Last Out Date"

                type="date"

                value={coachEditForm.last_out_date}

                onChange={(e) =>

                  setCoachEditForm((p) => ({

                    ...p,

                    last_out_date: e.target.value,

                  }))

                }

                InputLabelProps={{ shrink: true }}

                fullWidth

              />

            </Stack>

            <TextField

              select

              label="Repair Type"

              value={coachEditForm.repair_type_code}

              onChange={(e) =>

                setCoachEditForm((p) => ({

                  ...p,

                  repair_type_code: e.target.value,

                }))

              }

              fullWidth

            >

              <MenuItem value="">None</MenuItem>

              {(coachMasters.repairTypes || []).map((x) => (

                <MenuItem key={x.code} value={x.code}>

                  {x.name} ({x.code})

                </MenuItem>

              ))}

            </TextField>

            <TextField

              label="Remark"

              value={coachEditForm.remark}

              onChange={(e) =>

                setCoachEditForm((p) => ({ ...p, remark: e.target.value }))

              }

              fullWidth

              multiline

              minRows={3}

            />

          </Stack>

        </DialogContent>

        <DialogActions sx={{ p: 2 }}>

          <Button

            onClick={() => setCoachEditOpen(false)}

            disabled={coachEditSaving}

          >

            Cancel

          </Button>

          <Button

            variant="contained"

            onClick={saveCoachEdit}

            disabled={coachEditSaving}

          >

            {coachEditSaving ? "Saving..." : "Update Coach"}

          </Button>

        </DialogActions>

      </Dialog>

      {/* Original complete coach history dialog */}

      <CoachHistoryDialog

        coachNo={historyCoachNo}

        open={historyOpen}

        onClose={() => setHistoryOpen(false)}

      />

    </Box>

  );

}
